// components/ui/categories-section.jsx
import React, { useState, useEffect } from "react";
import FoodCategories from "@/components/ui/food-categories";
import DrinkCategories from "@/components/ui/drink-categories";

const CategoriesSection = ({
  selectedMainCategory,
  categories,
  onSelectSubcategory,
  selectedSubCategory,
}) => {
  console.log("[CategoriesSection] Render with:", {
    selectedMainCategory,
    selectedSubCategory,
  });
  return (
    <>
      {selectedMainCategory === "comidas" && (
        <FoodCategories
          categories={categories.kitchen || []}
          onSelectSubcategory={onSelectSubcategory}
          selectedSubcategory={selectedSubCategory}
        />
      )}
      {selectedMainCategory === "bebidas" && (
        <DrinkCategories
          categories={categories.drinks || []}
          onSelectSubcategory={onSelectSubcategory}
          selectedSubcategory={selectedSubCategory}
        />
      )}
    </>
  );
};

export default CategoriesSection;
